var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"c-base-button-bottom button"},[_vm._t("default",function(){return [_vm._v("Cadastrar ou criar minha conta")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }